export const SettingStoreConstant = {
  SWITCH_POPUP: "SWITCH_POPUP",
  FETCH_CONTRACTS: "FETCH_CONTRACTS",
  FETCH_CONFIG: "FETCH_CONFIG",
  SET_BC_CONFIGURATION: "SET_BC_CONFIGURATION",
};
